// src/components/Layout.jsx

import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../App.css";

/**
 * App.js renders <Layout><Routes>…</Routes></Layout>, so pages arrive as
 * `children`. (An earlier draft used react-router's <Outlet />, which only
 * resolves for nested <Route> definitions — with this structure it renders
 * nothing, leaving the header and footer visible above an empty page.)
 */
function Layout({ children }) {
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("adminToken");
    navigate("/login");
  };

  return (
    <>
      {/* Lets a keyboard or screen-reader user jump past the nav rather than
          tabbing through every link on each page. Visible only on focus —
          see .skip-link in App.css. */}
      <a href="#main" className="skip-link">
        Skip to content
      </a>

      <header className="main-header">
        {/* NavLink sets aria-current="page" automatically, which drives the
            active-state underline in App.css and tells a screen reader which
            page it is on. Plain <Link> did neither.

            Labels are shortened from the originals: "The Chronicles of Aomi"
            was the widest item and forced the mobile nav to wrap to three
            rows. The emoji prefixes are gone too — they cost horizontal space
            and are announced literally ("cyclone Homepage"). */}
        <nav className="nav-bar" aria-label="Main">
          <NavLink to="/" end>
            Home
          </NavLink>
          <NavLink to="/cartoons">Chronicles</NavLink>
          <NavLink to="/items">Gallery</NavLink>
          {isAdmin && <NavLink to="/admin">Admin</NavLink>}

          {isAdmin && (
            <button
              type="button"
              onClick={handleLogout}
              className="logout-button"
            >
              Log out
            </button>
          )}
        </nav>
      </header>

      {/* tabIndex={-1} makes this focusable as the skip-link target without
          adding it to the tab order. */}
      <main id="main" tabIndex={-1}>
        {children}
      </main>

      <footer className="footer">
        <p>© {new Date().getFullYear()} Marcelle Phillipe · The Living Tapestry</p>
      </footer>
    </>
  );
}

export default Layout;